import { ActionOptionsArgs, BaseObjectAction, PersistableAction } from '../../../core/store/actions/base-actions';

export const ENTITY = 'config';
export const CLEAR_LAST_SYNC_DOWN_DATES = '[Config] Last Sync Down Dates Remove';
export const SET_LAST_SYNC_DOWN = '[Config] Last Sync Down';
export const SET_AUTH_TOKEN = '[Config] Auth Token';
export const SET_REFRESH_TOKEN = '[Config] Refresh Token';
export const SET_REST_HOST = '[Config] Rest Host';
export const UPDATE_REST_HOST = '[Config] Update Rest Host';
export const SET_REST_ENDPOINT = '[Config] Rest Endpoint';
export const UPDATE_REST_ENDPOINT = '[Config] Update Rest Endpoint';
export const UPDATE_REST_HOST_AND_ENDPOINT = '[Config] Update Rest Host and Endpoint';

export class ClearLastSyncDownDates extends PersistableAction {
    readonly entity = ENTITY;
    readonly type = CLEAR_LAST_SYNC_DOWN_DATES;

    constructor() {
        super(undefined, undefined);
    }

    getKey(): string {
        return `${this.entity}:value:lastSyncDown`;
    }
}

export class SetLastSyncDownAction extends PersistableAction {
    readonly entity = ENTITY;
    readonly type = SET_LAST_SYNC_DOWN;

    constructor(
        public payload: {accountId: string, date: string},
        options?: ActionOptionsArgs
    ) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:value:lastSyncDown`;
    }
}

export class SetAuthTokenAction extends PersistableAction {
    readonly entity = ENTITY;
    readonly type = SET_AUTH_TOKEN;

    constructor(public payload: string, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:value:authToken`;
    }
}

export class SetRefreshTokenAction extends PersistableAction {
    readonly entity = ENTITY;
    readonly type = SET_REFRESH_TOKEN;

    constructor(public payload: string, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:value:refreshToken`;
    }
}

export class SetRestHostAction extends PersistableAction {
    readonly entity = ENTITY;
    readonly type = SET_REST_HOST;

    constructor(public payload: string, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:value:restHost`;
    }
}

export class UpdateRestHostAction extends BaseObjectAction {
    readonly entity = ENTITY;
    readonly type = UPDATE_REST_HOST;

    constructor(public payload: string, options?: ActionOptionsArgs) {
        super(payload, options);
    }
}

export class SetRestEndpointAction extends PersistableAction {
    readonly entity = ENTITY;
    readonly type = SET_REST_ENDPOINT;

    constructor(public payload: string, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:value:restEndpoint`;
    }
}

export class UpdateRestEndpointAction extends BaseObjectAction {
    readonly entity = ENTITY;
    readonly type = UPDATE_REST_ENDPOINT;

    constructor(public payload: string, options?: ActionOptionsArgs) {
        super(payload, options);
    }
}

export interface UpdateRestHostAndEndpointActionPayload {
    host: string;
    endpoint: string;
}

export class UpdateRestHostAndEndpointAction extends BaseObjectAction {
    readonly entity = ENTITY;
    readonly type = UPDATE_REST_HOST_AND_ENDPOINT;

    constructor(public payload: UpdateRestHostAndEndpointActionPayload, options?: ActionOptionsArgs) {
        super(payload, options);
    }
}

export type Actions
    = ClearLastSyncDownDates
    | SetLastSyncDownAction
    | SetAuthTokenAction
    | SetRefreshTokenAction
    | SetRestHostAction
    | UpdateRestHostAction
    | SetRestEndpointAction
    | UpdateRestEndpointAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/config/config.actions.ts